import i18n from '@/libs/i18n'

const companyDomains = {
  computed: {
    companyTypesLabel() {
      return {
        Store: this.$t('Loja'),
        Hub: this.$t('Hub'),
        DistributionCenter: this.$t('Centro de distribuição'),
      }
    },
  },

  methods: {
    companyTypes() {
      return [
        { value: 'Store', label: this.$t('Loja') },
        { value: 'Hub', label: this.$t('Hub') },
        { value: 'DistributionCenter', label: this.$t('Centro de distribuição') },
      ]
    },
    permitLicensesTypes() {
      return [
        { value: 'Operating', label: i18n.t('Alvará de Funcionamento') },
        { value: 'FireDepartment', label: i18n.t('Alvará do Corpo de Bombeiros') },
        { value: 'RentalContract', label: i18n.t('Contrato de Locação de Imóvel') },
        { value: 'RentalAdjust', label: i18n.t('Reajuste de Contrato de Locação de Imóvel') },
        { value: 'PropertyTax', label: i18n.t('IPTU') },
      ]
    },
    getPermitLicenseType(licenseType) {
      const type = this.permitLicensesTypesOptions.find(
        permitLicenseType => permitLicenseType.value === licenseType
      )

      return type ? type.label : ''
    },
  },
}

export default companyDomains
